<div class="dialog-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="dialog-header" cdkDragHandle>
        <h2 mat-dialog-title>Edit Object Parameters</h2>
        <button mat-icon-button mat-dialog-close class="close-button">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
        <div class="object-info">
            <h3>Object: {{ data.object?.name || 'Unnamed Object' }}</h3>
            <p class="object-type">Type: {{ data.object?.userData?.typ || 'Unknown' }}</p>
        </div>

        <form [formGroup]="parametersForm" class="parameters-form">
            <div class="parameter-grid">
                <div *ngFor="let key of parameterKeys" class="parameter-row"
                    [class.numeric-parameter]="isNumericParameter(key)" [class.color-parameter]="isColorParameter(key)">

                    <label class="parameter-label">{{ getParameterDisplayName(key) }}</label>

                    <!-- Numeric input -->
                    <input *ngIf="isNumericParameter(key)" type="number" [formControlName]="key"
                        class="parameter-input numeric-input" step="any">

                    <!-- Color input -->
                    <input *ngIf="isColorParameter(key)" type="color" [formControlName]="key"
                        class="parameter-input color-input">

                    <!-- Text input for everything else -->
                    <input *ngIf="!isNumericParameter(key) && !isColorParameter(key)" type="text"
                        [formControlName]="key" class="parameter-input text-input">

                    <!-- Display original value -->
                    <span class="original-value">
                        Original: {{ originalValues[key] || 'N/A' }}
                    </span>
                </div>
            </div>
        </form>

        <div *ngIf="parameterKeys.length === 0" class="no-parameters">
            <p>No editable parameters found for this object.</p>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="resetForm()" [disabled]="!hasChanges()" class="reset-button">
            Reset
        </button>

        <button mat-button (click)="onCancel()" class="cancel-button">
            Cancel
        </button>

        <button mat-raised-button color="primary" (click)="onApply()" [disabled]="!isFormValid() || !hasChanges()"
            class="apply-button">
            Apply Changes
        </button>
    </div>
</div>